import React, { useEffect, useState } from 'react';

import { message } from 'antd';
import { withRouter } from 'react-router-dom';

import Loading from '$app/shared/components/Loading';

import { fetchPredefinedPrice, getErrorMessage, updatePredefinedPrice } from '../../productApi';
import PriceFormFields, {
  buildUpdatePricePayload,
  normalizePriceFormData,
  usePriceFormState,
} from '../PriceForm';
import PriceFormPage from '../PriceFormPage';

function PriceEditPage(props) {
  const { editForm, history, patchPrices } = props;
  const { formData, updateField } = usePriceFormState(editForm, normalizePriceFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const description = formData.description.trim();
    if (!description) {
      message.error('Description is required');
      return;
    }

    try {
      setIsSubmitting(true);
      await patchPrices(
        buildUpdatePricePayload({
          ...formData,
          description,
        }),
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PriceFormPage history={history} title="Edit Price" onSubmit={handleSubmit} isSubmitting={isSubmitting}>
      <PriceFormFields formData={formData} onFieldChange={updateField} showStatus showAccountingFields />
    </PriceFormPage>
  );
}

function PriceEditPageContainer(props) {
  const { history, match } = props;
  const { predefinedId, sku } = match.params;
  const [editForm, setEditForm] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadForm = async () => {
      try {
        const price = await fetchPredefinedPrice(predefinedId);
        if (isMounted) {
          setEditForm(price);
        }
      } catch (error) {
        message.error(getErrorMessage(error));
      }
    };

    loadForm();

    return () => {
      isMounted = false;
    };
  }, [predefinedId]);

  if (!editForm) {
    return <Loading />;
  }

  return (
    <PriceEditPage
      {...props}
      editForm={editForm}
      patchPrices={async (formData) => {
        try {
          await updatePredefinedPrice(predefinedId, formData);
          message.success('Price updated');
          history.push(`/edit/${sku}/prices`);
        } catch (error) {
          message.error(getErrorMessage(error));
        }
      }}
    />
  );
}

export default withRouter(PriceEditPageContainer);
